// FTEDN Creator — Voting Page (wired to real data)
import { useEffect, useState } from 'react';
import { useVotingStore } from '../../stores/voting.store';
import { useUserStore } from '../../stores/user.store';
import { VoteFlipCard } from './VoteFlipCard';
import { IdeaForm } from './IdeaForm';
import { VoteResults } from './VoteResults';
import { Skeleton } from '../../components/ui/Skeleton';
import { EmptyState } from '../../components/ui/EmptyState';
import { getVotePower, CATEGORY_ICONS } from './voting.helpers';
import './VotingPage.css';

const CATEGORIES = ['all', 'product', 'scent', 'packaging', 'ingredient'];

export function VotingPage() {
  const [showIdeaForm, setShowIdeaForm] = useState(false);
  const [activeCategory, setActiveCategory] = useState('all');
  const [showResults, setShowResults] = useState(false);
  const { cards, loading, fetchCards, castVote } = useVotingStore();
  const { profile } = useUserStore();

  useEffect(() => {
    fetchCards();
  }, [fetchCards]);

  const votePower = getVotePower(profile?.level ?? 1);

  const filtered = activeCategory === 'all'
    ? cards
    : cards.filter(c => c.category === activeCategory);

  return (
    <div className="voting-page page-enter">
      <div className="voting-header">
        <div>
          <h1>🗳️ Vote & Create</h1>
          <p className="voting-subtitle">Shape what OOEDN builds next. Every vote matters.</p>
        </div>
        <div className="voting-header-right">
          <div className="vote-power">
            <span className="vote-power-icon">⚡</span>
            <span className="vote-power-num">{votePower}x</span>
            <span className="vote-power-label">Vote Power</span>
          </div>
          <button className="neo-btn neo-btn--ghost" onClick={() => setShowResults(!showResults)}>
            {showResults ? '🗳️ Cards' : '📊 Results'}
          </button>
          <button className="neo-btn neo-btn--gold" onClick={() => setShowIdeaForm(!showIdeaForm)} id="submit-idea-btn">
            {showIdeaForm ? '✕ Close' : '💡 Submit Idea'}
          </button>
        </div>
      </div>

      {/* Category pills */}
      <div className="category-pills">
        {CATEGORIES.map(cat => (
          <button key={cat} className={`category-pill ${activeCategory === cat ? 'active' : ''}`}
                  onClick={() => setActiveCategory(cat)}>
            {cat === 'all' ? '🌐 All' : `${CATEGORY_ICONS[cat] || '📋'} ${cat}`}
          </button>
        ))}
      </div>

      {showIdeaForm && <IdeaForm onClose={() => setShowIdeaForm(false)} />}

      {loading ? (
        <div className="voting-grid">
          <Skeleton variant="card" count={6} />
        </div>
      ) : filtered.length === 0 ? (
        <EmptyState
          icon="🗳️"
          title="No cards yet"
          description={activeCategory === 'all' ? 'Voting cards will appear here soon.' : `No ${activeCategory} cards to vote on yet.`}
        />
      ) : showResults ? (
        <VoteResults cards={filtered} />
      ) : (
        <div className="voting-grid">
          {filtered.map((card, i) => (
            <VoteFlipCard
              key={card.id}
              card={{ ...card, desc: card.description }}
              index={i}
              onVote={() => castVote(card.id)}
              alreadyVoted={card.userVoted}
            />
          ))}
        </div>
      )}
    </div>
  );
}
